module.exports = __webpack_public_path__ + "static/media/testitemimage.78347ffc.png";